package org.zest.insan_360_website.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet.invoke
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*
import kotlin.js.Date
import kotlin.time.Duration.Companion.milliseconds

enum class ToastType { SUCCESS, ERROR, INFO }

data class ToastData(
    val message: String,
    val type: ToastType,
    val id: Double = Date.now(),
)

class ToastState {
    var currentToast by mutableStateOf<ToastData?>(null)
        private set

    fun show(message: String, type: ToastType = ToastType.INFO) {
        currentToast = ToastData(message, type)
    }

    fun hide() {
        currentToast = null
    }
}

val LocalToast = staticCompositionLocalOf<ToastState> {
    error("No ToastState provided. Wrap your app in a ToastProvider.")
}

@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun ToastContainer(toastState: ToastState) {
    val activeToast = toastState.currentToast
    val isVisible = activeToast != null
    var retainedToast by remember { mutableStateOf<ToastData?>(null) }

    if (activeToast != null) {
        retainedToast = activeToast
    }

    LaunchedEffect(activeToast) {
        if (activeToast != null) {
            delay(3500.milliseconds)
            toastState.hide()
        }
    }

    LaunchedEffect(isVisible) {
        if (!isVisible) {
            delay(400.milliseconds)
            retainedToast = null
        }
    }

    val bgColor = when (retainedToast?.type) {
        ToastType.SUCCESS -> Color.rgb(73, 209, 174).darkened(0.25f) // Your mainColor
        ToastType.ERROR -> Colors.Crimson
        ToastType.INFO -> Colors.DarkSlateGray
        null -> Colors.Transparent
    }

    Box(
        modifier = Modifier
            .position(Position.Fixed)
            .bottom(if (isVisible) 2.cssRem else (-12).cssRem)
            .left(50.percent)
            .transform { translateX((-50).percent) }
            .zIndex(9999) // Always on top
            .backgroundColor(bgColor)
            .color(Colors.White)
            .padding(leftRight = 1.5.cssRem, topBottom = 0.75.cssRem)
            .borderRadius(0.5.cssRem)
            .boxShadow(0.px, 4.px, 6.px, color = Colors.Black.copyf(alpha = 0.3f))
            .transition {
                "bottom" { duration(0.3.s) }
                "background-color" { duration(0.3.s) }
            }
            .userSelect(UserSelect.None),
        contentAlignment = Alignment.Center
    ) {
        SpanText(
            modifier = Modifier.textAlign(TextAlign.Center),
            text = retainedToast?.message ?: ""
        )
    }
}